




















import { Component, Prop, Vue } from 'vue-property-decorator';
import MyWearables from '@/components/MyWearables.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { Alpaca } from '@/backend/type';
import { validateAccount } from '@/utils/web3';

@Component({
  components: {
    MyWearables,
    AlpacaBtn,
  },
})
export default class Scarves extends Vue {
  public activeTab: string = 'my-scarves';

  get account() {
    return this.$store.getters.getAccount;
  }

  public isCurrentTab(tab: string) {
    return this.activeTab === tab;
  }

  public routeTo(name: string) {
    this.$router.push({name});
  }

  public async connectWallet() {
    await validateAccount(this);
  }

  public changeTab(tab: string) {
    this.activeTab = tab;
  }
}
